import React, { FC, useMemo } from 'react';

import DropdownSelect, { DropdownSelectProps } from '@/components/fields/DropdownSelect';
import { useOffices } from '@/hooks/useOffices';

type OfficeDropdownSelectProps = Omit<DropdownSelectProps, 'options'> & {
  allowedOffices?: string[];
};

const OfficeDropdownSelect: FC<OfficeDropdownSelectProps> = props => {
  const { officesOptions } = useOffices();

  const officeOptions = useMemo(
    () =>
      officesOptions
        .map(({ id, label }) => ({ value: id, label }))
        .filter(({ value }) => (props.allowedOffices ? props.allowedOffices?.includes(value) : true)),
    [officesOptions, props.allowedOffices]
  );

  return <DropdownSelect {...props} options={officeOptions} />;
};

export default OfficeDropdownSelect;
